<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        const query = await stuff.cms.privacyPolicy();
        return {
            props: {
                query,
            },
        };
    };
</script>

<script lang="ts">
    import type { PrivacyPolicyQuery } from '$gen/graphql';
    import SeoMetaTags from '$lib/components/SeoMetaTags.svelte';
    import { localStore, type LocalStorageModel } from '$lib/privacy-banner/localStore';

    export let query: PrivacyPolicyQuery;

    $: content =
        query?.entry?.__typename === 'privacyPolicy_privacyPolicy_Entry' ? query.entry : null;

    function updateInstaEmbed(event) {
        const value: LocalStorageModel['instaEmbed'] = event.target.value;
        if (value === 'allowed') {
            $localStore.instaEmbed = 'allowed';
        } else if (value === 'forbidden') {
            $localStore.instaEmbed = 'forbidden';
        } else {
            console.warn("updateInstaEmbed can't handle this value");
        }
        // console.log('User will was updated:', $localStore);
    }
</script>

<SeoMetaTags seo={content?.seo} />

<section
    class="redactor mt-5 min-h-screen max-w-[100vw] space-y-5 overflow-hidden text-xl leading-5 md:text-2xl md:leading-6"
>
    {#if content}
        {@html content.redactor}
    {/if}
</section>
<section class="mb-5">
    <p>
        Embedded Instagram posts are :
        <select name=" " id="" value={$localStore.instaEmbed} on:change={updateInstaEmbed}>
            <option value="allowed">allowed</option>
            <option value="forbidden">forbidden</option>
        </select>
    </p>
</section>

<style>
    .redactor :global(*) {
        white-space: pre-line;
    }
</style>
